import React from "react";

import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const Billing = lazyLoader(
  () => import("Containers/Settings/GeneralSettings/Billing/Billing"),
);

export const GeneralSettingBilling = () => {
  return (
    <Layout>
      <Billing />
    </Layout>
  );
};
